import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AttachmentModel } from '../../content/recourse-booking/model/attachment.model';
import { completeEndpoint, EndpointPart } from '../../core/global';
import { EndpointService } from '../endpoint/endpoint.service';

@Injectable({
  providedIn: 'root',
})
export class AttachmentService {
  private readonly http = inject(HttpClient);
  private readonly endpointService = inject(EndpointService);

  public delete(id: number): Observable<any> {
    const pathParams: Map<string, number> = new Map();
    pathParams.set('pkAttachmentId', id);
    const url: string = this.endpointService.getEndpointUrl(
      completeEndpoint(EndpointPart.DELETE_ATTACHMENT_BY_ID),
      pathParams,
    );
    return this.http.delete<any>(url);
  }

  public download(id: number): Observable<any> {
    const pathParams: Map<string, number> = new Map();
    pathParams.set('pkAttachmentId', id);
    const url: string = this.endpointService.getEndpointUrl(
      completeEndpoint(EndpointPart.GET_DOWNLOAD_ATTACHMENT_BY_ID),
      pathParams,
    );
    return this.http.get<any>(url, { responseType: 'blob' as 'json' });
  }

  public upload(formData: FormData, keepBookingState?: boolean): Observable<any> {
    let requestParams = {};
    if (keepBookingState) {
      requestParams = new HttpParams().set('keepBookingState', Boolean(keepBookingState).toString());
    }
    const url: string = this.endpointService.getEndpointUrl(completeEndpoint(EndpointPart.POST_UPLOAD_ATTACHMENT));

    return this.http.post(url, formData, { params: requestParams });
  }

  public getAttachmentsByTopic(topic: string): Observable<AttachmentModel[]> {
    const pathParams: Map<string, string> = new Map();
    pathParams.set('topic', topic);
    const url: string = this.endpointService.getEndpointUrl(
      completeEndpoint(EndpointPart.GET_ALL_ATTACHMENTS_BY_TOPIC),
      pathParams,
    );
    return this.http.get<AttachmentModel[]>(url);
  }

  public getAttachmentsByCampaignAndTopic(recourseId: string, topic: string): Observable<AttachmentModel[]> {
    const pathParams: Map<string, string> = new Map();
    pathParams.set('recourseId', recourseId);
    pathParams.set('topic', topic);
    const url: string = this.endpointService.getEndpointUrl(
      completeEndpoint(EndpointPart.GET_ALL_ATTACHMENTS_BY_CAMPAIGN_TOPIC),
      pathParams,
    );
    return this.http.get<AttachmentModel[]>(url);
  }

  public getAttachmentsByRecourseBooking(recourceBookingId: number): Observable<AttachmentModel[]> {
    const pathParams: Map<string, number> = new Map();
    pathParams.set('recourceBookingId', recourceBookingId);
    const url: string = this.endpointService.getEndpointUrl(
      completeEndpoint(EndpointPart.GET_ALL_ATTACHMENTS_BY_BOOKING),
      pathParams,
    );
    return this.http.get<AttachmentModel[]>(url);
  }
}
